import { SvgIcon, SvgIconProps, useTheme } from "@mui/material";

const EbsSvgIcon = ({ primary }: SvgIconProps & { primary?: boolean }) => {
  const { palette } = useTheme();

  const color = primary ? palette.primary.main : palette.action.active;

  return (
    <SvgIcon>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19.2542 17.347H20.0178V20.4016H16.9632V19.6379H18.7944L16.6757 17.2168L17.2508 16.7136L19.2542 19.0033V17.347ZM6.94166 17.2168L4.82296 19.6379H6.65416V20.4016H3.59961V17.347H4.36325V19.0033L6.36665 16.7136L6.94166 17.2168ZM20.0178 3.60156V6.65611H19.2542V4.99978L17.2508 7.28954L16.6757 6.78631L18.7944 4.3652H16.9632V3.60156H20.0178ZM4.82296 4.3652L6.94166 6.78631L6.36665 7.28954L4.36325 4.99978V6.65611H3.59961V3.60156H6.65416V4.3652H4.82296ZM11.8087 8.94702C9.51512 8.94702 8.56325 8.44951 8.56325 8.18338C8.56325 7.88824 9.44448 7.41974 11.8087 7.41974C14.0473 7.41974 15.0542 7.86609 15.0542 8.18338C15.0542 8.44951 14.1023 8.94702 11.8087 8.94702ZM11.8415 16.2016C9.58041 16.2016 8.56325 15.7552 8.56325 15.4379V9.18451C9.4819 9.64193 11.0019 9.71065 11.8087 9.71065C12.6155 9.71065 14.1355 9.64193 15.0542 9.18451V15.4379C15.0542 15.7552 14.0576 16.2016 11.8415 16.2016ZM11.8087 6.65611C9.97979 6.65611 7.79961 6.92109 7.79961 8.18338V15.4379C7.79961 16.7002 9.99774 16.9652 11.8415 16.9652C13.3268 16.9652 15.8178 16.7667 15.8178 15.4379V8.18338C15.8178 6.85465 13.3062 6.65611 11.8087 6.65611Z"
          fill={color}
        />
      </svg>
    </SvgIcon>
  );
};

EbsSvgIcon.muiName = "EksSvgIcon";

export default EbsSvgIcon;
